import React from 'react';
import { makeStyles } from 'react-scale/components/ui/styles';

interface INERWatermarkProps {
  loggedUserId?: string;
}

const LINE_HEIGHT = 25;

// Mostly copied from frontend/components/scalers/tasks/textcollection/ProtectedTextAttachment.tsx
const wrapText = (context: CanvasRenderingContext2D, word: string, maxSize: number) => {
  let y = 0;
  if (!context) return;
  let line = '';

  while (y < maxSize) {
    line += word + ' ';
    const metrics = context.measureText(line);
    const testWidth = metrics.width;
    if (testWidth > maxSize) {
      context.fillText(line, 0, y);
      line = '';
      y += LINE_HEIGHT;
    }
  }
  context.fillText(line, 0, y);
};

const NERWatermark = (props: INERWatermarkProps) => {
  const { loggedUserId = 'USERID' } = props;
  const containerRef = React.useRef<HTMLDivElement>(null);
  const overlayRef = React.useRef<HTMLCanvasElement>(null);
  const styles = useNERWatermarkStyles();

  React.useEffect(() => {
    const container = containerRef.current;
    const overlay = overlayRef.current;
    if (!overlay || !container) {
      return;
    }
    const ctx = overlay.getContext('2d');
    if (!ctx) {
      return;
    }

    const width = container.offsetWidth || 700;
    const height = container.offsetHeight || 700;
    const length = Math.round(Math.sqrt(Math.pow(width, 2) + Math.pow(height, 2)));

    overlay.width = length;
    overlay.height = length;

    ctx.font = 'normal 14px Arial';
    ctx.translate(-width / 4, height / 2);
    ctx.rotate(-Math.PI / 4);
    ctx.fillStyle = '#bbb';
    ctx.globalAlpha = 0.2;
    const watermark = loggedUserId;
    wrapText(ctx, watermark, length);
    ctx.restore();
  }, [loggedUserId]);

  return (
    <div ref={containerRef} className={styles.container}>
      <canvas ref={overlayRef} />
    </div>
  );
};

const useNERWatermarkStyles = makeStyles({
  container: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    zIndex: 3,
    overflow: 'hidden',
    pointerEvents: 'none',
  },
});

export default NERWatermark;
